import { AngularTableColumn } from './angular-table-column';

export class AngularTableResponsiveColumn {
    title: string;
    name: string;
    cssClass: string;
    intestazione: boolean;
    static generate = function (tableColumns: AngularTableColumn[]): AngularTableResponsiveColumn[] {
        let result : AngularTableResponsiveColumn[] = null;
        if(tableColumns && tableColumns.length > 0) {
            result = new Array<AngularTableResponsiveColumn>();
            tableColumns.forEach(c => {
                let rc = new AngularTableResponsiveColumn();
                rc.title = c.title;
                rc.name = c.name;
                rc.intestazione = false;
                rc.cssClass = null;
                result.push(rc);
            });
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-table-responsive-column.ts